import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Icon } from './Icon';
export function Logo({ full }: { full?: boolean }) {
  return (
    <div className={`brand${full ? ' brand--full' : ''}`}>
      <img
        src="/zenith-logo-trim.jpg"
        className={`brand__img${full ? ' brand__img--full' : ' brand__img--hdr'}`}
        alt="ZENITH"
      />
    </div>
  );
}
export function Header({back,title,meta}:{back?:boolean;title?:string;meta?:string}){const navigate=useNavigate();const{profile}=useAuth();if(back)return <header className="detail-header"><button className="icon-button" onClick={()=>history.length>1?history.back():navigate('/forums')} aria-label="Go back"><Icon name="back"/></button><div><h1>{title}</h1>{meta&&<p>{meta}</p>}</div></header>;return <header className="app-header"><Logo/><div className="app-header__right"><span className="live"><i/>LIVE</span><button className="profile-chip" onClick={()=>navigate('/profile')} aria-label="Open profile"><span>{profile?.codename??'GUEST'}</span><small>L{profile?.level??1}</small></button></div></header>}
